export default __webpack_public_path__ + "static/media/labStory.2216948f.mp3";